/* eslint-disable */
import { useEffect, useRef, useState } from 'react';

const ANIMATION_START = 'animationstart';
const ANIMATION_END = 'animationend';

export const FlipCountdown = ({ endTimestamp }) => {
  const [containerClassName, setContainerClassName] = useState('count-down-container');
  const minutesTensRef = useRef(null);
  const minutesOnesRef = useRef(null);
  const secondsTensRef = useRef(null);
  const secondsOnesRef = useRef(null);
  const animationFrame = useRef(null);
  const lastTimeRef = useRef(0);

  const updateTimer = (currentTime) => {
    if (currentTime - lastTimeRef.current >= 1000) {
      lastTimeRef.current = currentTime;

      const timeBetweenDates = Math.floor((endTimestamp - performance.now()) / 1000);
      if (timeBetweenDates >= 0) {
        flipAllCards(timeBetweenDates);

        if (timeBetweenDates <= 10 && containerClassName !== 'count-down-container red') {
          setContainerClassName('count-down-container red');

          // if (timeBetweenDates === 3) {
          //   setActiveScene(GameScenes.TRANSITION_COUNT_DOWN);
          // }
        }
      } else {
        cancelAnimationFrame(animationFrame.current);
        return;
      }
    }

    animationFrame.current = requestAnimationFrame(updateTimer);
  };
  const flipAllCards = (time) => {
    const seconds = time % 60;
    const minutes = Math.floor(time / 60) % 60;

    flip(minutesTensRef.current, Math.floor(minutes / 10));
    flip(minutesOnesRef.current, minutes % 10);
    flip(secondsTensRef.current, Math.floor(seconds / 10));
    flip(secondsOnesRef.current, seconds % 10);
  };
  const flip = (flipCard, newNumber) => {
    if (!flipCard) {
      return;
    }

    const [topHalf, bottomHalf] = flipCard.children;
    const startNumber = topHalf.textContent;
    if (newNumber === parseInt(startNumber)) {
      return null;
    }
    const topFlip = document.createElement('div');
    const bottomFlip = document.createElement('div');

    topFlip.classList.add('top-flip');
    bottomFlip.classList.add('bottom-flip');
    topFlip.textContent = startNumber;
    bottomHalf.textContent = startNumber;
    bottomFlip.textContent = newNumber;
    topFlip.addEventListener(ANIMATION_END, () => topFlip.remove());
    topFlip.addEventListener(ANIMATION_START, () => (topHalf.textContent = newNumber));
    bottomFlip.addEventListener(ANIMATION_END, () => {
      // eslint-disable-next-line
      bottomHalf.textContent = newNumber;
      bottomFlip.remove();
    });

    flipCard.append(topFlip, bottomFlip);
  };

  useEffect(() => {
    animationFrame.current = requestAnimationFrame(updateTimer);

    return () => {
      cancelAnimationFrame(animationFrame.current);
    };
  }, [endTimestamp]);

  return (
    <div className={containerClassName}>
      <div className='container-segment'>
        <div className='segment'>
          <div className='flip-card' ref={minutesTensRef}>
            <div className='top'>-</div>
            <div className='bottom'>-</div>
          </div>
          <div className='flip-card' ref={minutesOnesRef}>
            <div className='top'>-</div>
            <div className='bottom'>-</div>
          </div>
        </div>
      </div>
      <div className='count-down-dot-container'>
        <div className='count-down-dot' />
        <div className='count-down-dot' />
      </div>
      <div className='container-segment'>
        <div className='segment'>
          <div className='flip-card' ref={secondsTensRef}>
            <div className='top'>-</div>
            <div className='bottom'>-</div>
          </div>
          <div className='flip-card' ref={secondsOnesRef}>
            <div className='top'>-</div>
            <div className='bottom'>-</div>
          </div>
        </div>
      </div>
    </div>
  );
};
